import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import {
	AfterViewInit,
	ApplicationRef,
	Component,
	ComponentRef,
	createComponent,
	EnvironmentInjector,
	inject,
	OnDestroy,
	OnInit,
} from '@angular/core';
import {
	Map,
	StyleFunction,
	GeoJSON,
	geoJSON,
	LayerGroup,
	divIcon,
	marker,
	layerGroup,
	Point,
} from 'leaflet';
import { Position } from 'pdfmake/interfaces';
import { VariaveisService } from '../../../../services/variaveis.service';
import {
	FormularioRelatorio,
	INPUTS_RELATORIOS_PCDS,
} from '@modulos/home/submodulos/dados-meteorologicos/interfaces';
import {
	getUnidadeVariavelAcompanhamentoColeta,
	VariavelAcompanhamentoColeta,
} from '../../interfaces/variaveis';
import { RelatorioVariavelEstacao } from '../../interfaces/estacao-ultimas-medicoes';
import { RelatoriosService } from '@modulos/home/submodulos/dados-meteorologicos/services';
import { ColorUtils } from '@utils/color-utils';
import {
	alinharDado,
	baixarEAbrirPDF,
	isNotNuloOuUndefined,
	numberToBrNumber,
	numberToBrNumberTables,
} from '@utils';
import { ToastrService } from 'ngx-toastr';
import { PopupVariaveisMunicipioComponent } from '../popup-variaveis-municipio/popup-variaveis-municipio.component';
import { DateTimeUtils } from '@utils/datetime-util';
import { Subject, takeUntil } from 'rxjs';
import { GroupButton } from '@componentes/public-button-group/public-button-group.component';
import { bootstrapLarguraSM } from '@utils/constants';
import * as Leaflet from 'leaflet';
import * as pdfseira from '@utils/pdf-seira';
import html2canvas from 'html2canvas';
import { format } from 'date-fns';
import ptBrLocale from 'date-fns/locale/pt-BR';
import { corrigeDuplicacaoNome } from '@modulos/home/submodulos/dados-meteorologicos/utils/corrige-duplicacao-nome';
import { DocumentExporter } from '@utils/document-exporter';
import * as ExcelTable from 'mr-excel';

@Component({
	selector: 'seira-mapa-variaveis-meteorologicas-estacao',
	templateUrl: './mapa-variaveis-meteorologicas-estacao.component.html',
	styleUrls: ['./mapa-variaveis-meteorologicas-estacao.component.scss'],
})
export class MapaVariaveisMeteorologicasEstacaoComponent
	implements AfterViewInit, OnDestroy, OnInit
{
	descricaoRelatorio =
		'Define-se como variável meteorológica por estação os valores dessa variável registrada na estação ao longo de um período.';
	labelPeriodo = '';
	labelVariavel = '';
	labelUnidadeVariavel = '';
	private _isCarregando: boolean;
	mapa!: Map;
	inputs = inject(INPUTS_RELATORIOS_PCDS);
	regiao?: Position[][];
	geoJsonLayer?: GeoJSON;
	markersLayer: LayerGroup;
	medicoes: RelatorioVariavelEstacao[] = [];
	_destroyed = new Subject<void>();
	centerDefault: Leaflet.LatLngExpression = [-7.2605416, -36.7290255];
	zoomDefault = 8;

	botoesDeExportacao: GroupButton[] = [
		{
			label: '.pdf',
			size: 'small',
			icon: 'ph-file-pdf',
			activeFakeLoading: true,
			onClick: () => this.exportarPDF(),
		},
		{
			label: '.csv',
			size: 'small',
			icon: 'ph-file-csv',
			onClick: () => this.exportarCSV(),
		},
		{
			label: '.txt',
			size: 'small',
			icon: 'ph-file-text',
			onClick: () => this.exportarTXT(),
		},
		{
			label: '.xlsx',
			size: 'small',
			icon: 'ph-file-xls',
			onClick: () => this.exportarXLSX(),
		},
	];

	constructor(
		private httpClient: HttpClient,
		private variavelService: VariaveisService,
		private relatoriosService: RelatoriosService,
		private toastr: ToastrService,
		private appRef: ApplicationRef,
		private envInjector: EnvironmentInjector
	) {
		this.markersLayer = layerGroup();
	}

	exportarXLSX() {
		const colorPalette = {
			c1: '2C3639',
			c2: 'FFFFFF',
			c3: '000000',
			c4: 'EEEEEE',
		};
		const rowStyle = {
			backgroundColor: colorPalette.c2,
			color: colorPalette.c3,
			alignment: {
				horizontal: 'left',
				vertical: 'center',
			} as ExcelTable.DataModel.AlignmentOption,
		};
		const headerStyle = {
			backgroundColor: colorPalette.c4,
			color: colorPalette.c1,
			bold: true,
		};
		const headerStyleCenter = {
			backgroundColor: colorPalette.c4,
			color: colorPalette.c1,
			bold: true,
			alignment: {
				horizontal: 'center',
				vertical: 'center',
			} as ExcelTable.DataModel.AlignmentOption,
		};
		const rowStyleCenter = {
			backgroundColor: colorPalette.c2,
			color: colorPalette.c3,
			alignment: {
				horizontal: 'center',
				vertical: 'center',
			} as ExcelTable.DataModel.AlignmentOption,
		};
		const title = {
			backgroundColor: colorPalette.c2,
			whiteSpace: 'pre',
			color: colorPalette.c3,
			bold: true,
			alignment: {
				horizontal: 'center',
				vertical: 'center',
				wrapText: 1,
			} as ExcelTable.DataModel.AlignmentOption,
		};

		const headers = [
			{ label: 'municipioPosto', text: 'Município/Posto', size: 24 },
			{ label: 'latitude', text: 'Latitude', size: 24 },
			{ label: 'longitude', text: 'Longitude', size: 24 },
			{ label: 'media', text: 'Média', size: 24 },
			{ label: 'minima', text: 'Mínima', size: 24 },
			{ label: 'maxima', text: 'Máxima', size: 24 },
			{ label: 'data', text: 'Data', size: 24 },
		];

		const dataExcel = {
			styles: {
				headerStyle,
				headerStyleCenter,
				rowStyle,
				rowStyleCenter,
				title,
			},
			sheet: [
				{
					shiftTop: 3,
					images: [
						{
							url: 'assets/images/cabecalho/cabeçalho_excel.png',
							from: 'A1',
							to: 'C3',
						},
					],
					styleCellCondition(
						data: any,
						object: any,
						rowIndex: number,
						colIndex: number,
						fromHeader: boolean,
						styleKeys: string[]
					) {
						if (data && data.label) {
							return 'headerStyleCenter';
						} else {
							if (colIndex === 0) {
								return 'rowStyle';
							} else {
								return 'rowStyleCenter';
							}
						}
					},
					headers: headers,
					data: Array.from(this.medicoes).map((item: any) => {
						const periodo = this.inputs.form
							.get(FormularioRelatorio.PERIODO_BUSCA)
							?.value?.toLowerCase();
						const periodoFormatado = this.formatarDataPeriodo(
							item.dataColeta,
							periodo
						);

						const latitude = parseFloat(
							numberToBrNumberTables(item.latitude, 4)
								?.replace('.', '')
								.replace(',', '.')
						);
						const longitude = parseFloat(
							numberToBrNumberTables(item.longitude, 4)
								?.replace('.', '')
								.replace(',', '.')
						);
						const valor = parseFloat(
							numberToBrNumberTables(item.valor, 2)
								?.replace('.', '')
								.replace(',', '.')
						);
						const valorMin = parseFloat(
							numberToBrNumberTables(item.valorMin, 2)
								?.replace('.', '')
								.replace(',', '.')
						);
						const valorMax = parseFloat(
							numberToBrNumberTables(item.valorMax, 2)
								?.replace('.', '')
								.replace(',', '.')
						);
						return {
							municipioPosto: corrigeDuplicacaoNome(
								`${item.municipio}/${item.nomePosto}`
							),
							latitude: item.latitude ? parseFloat(latitude.toFixed(4)) : '-',
							longitude: item.longitude
								? parseFloat(longitude.toFixed(4))
								: '-',
							media: item.valor ? parseFloat(valor.toFixed(2)) : '-',
							minima: item.valorMin ? parseFloat(valorMin.toFixed(2)) : '-',
							maxima: item.valorMax ? parseFloat(valorMax.toFixed(2)) : '-',
							data: periodoFormatado,
						};
					}),
					columns: [
						{ key: 'municipioPosto' },
						{
							key: 'latitude',
						},
						{
							key: 'longitude',
						},
						{
							key: 'media',
						},
						{
							key: 'minima',
						},
						{
							key: 'maxima',
						},
						{
							key: 'data',
						},
					],
					title: {
						consommeRow: 3,
						consommeCol: 3,
						text: this.getNomeArquivo(),
						styleId: 'title',
					},
				},
			],
			fileName: this.getNomeArquivo(),
		};

		ExcelTable.generateExcel(dataExcel);
	}

	exportarTXT() {
		const colunas = [
			'Município/Posto',
			'Latitude',
			'Longitude',
			'Média',
			'Mínima',
			'Máxima',
			'Data',
		];
		let txtData = `Agência Executiva de Gestão das Águas do Estado da Paraíba\n${this.getNomeArquivo()}\n\n\n`;
		const periodo = this.inputs.form
			.get(FormularioRelatorio.PERIODO_BUSCA)
			?.value?.toLowerCase();

		this.medicoes.forEach((item: any) => {
			const periodoFormatado = this.formatarDataPeriodo(
				item.dataColeta,
				periodo
			);

			const rowData = [
				corrigeDuplicacaoNome(`${item.municipio}/${item.nomePosto}`),
				numberToBrNumberTables(item.latitude, 4),
				numberToBrNumberTables(item.longitude, 4),
				numberToBrNumberTables(item.valor, 2),
				numberToBrNumberTables(item.valorMin, 2),
				numberToBrNumberTables(item.valorMax, 2),
				periodoFormatado,
			];
			rowData.forEach((data, index) => {
				txtData += `${colunas[index]}: ${data}\n`;
			});
			txtData += '\n';
		});

		DocumentExporter.gerarTXT(txtData, this.getNomeArquivo());
	}

	exportarCSV() {
		const header = [
			['Agência Executiva de Gestão das Águas do Estado da Paraíba'],
		];
		const title = [[`${this.getNomeArquivo()}\n\n`]];
		const tableData = this.getDadosVariavelMeteorologicaExportacao();

		let csvContent = header.concat(title);
		csvContent = csvContent.concat(tableData);
		const csvString = csvContent.map(row => row.join(';')).join('\n');

		DocumentExporter.gerarCSV(csvString, this.getNomeArquivo());
	}
	async exportarPDF() {
		const dataFormatada = format(
			new Date(),
			"dd 'de' MMMM 'de' yyyy 'às' HH'h'mm",
			{
				locale: ptBrLocale,
			}
		);

		this.mapa.setView(this.centerDefault, this.zoomDefault);
		await new Promise(resolve => setTimeout(resolve, 750));

		const documentDefinition: any = await pdfseira.documentDefinitions(
			'landscape'
		);
		const img = await this.getMapImage();
		documentDefinition.content.push([
			{
				text: `Variável meteorológica por estação - ${this.labelVariavel} ${this.labelUnidadeVariavel} - ${this.labelPeriodo}`,
				alignment: 'center',
				margin: [0, 15, 5, 15],
				fontSize: 12,
			},
			{
				text: `Relatório exportado em: ${dataFormatada}`,
				alignment: 'center',
				margin: [0, 15, 5, 15],
				fontSize: 10,
			},
			{
				image: img,
				width: window.innerWidth > bootstrapLarguraSM ? 450 : 200,
				height: window.innerWidth > bootstrapLarguraSM ? 300 : undefined,
				margin: [0, 15, 5, 50],
				alignment: 'center',
			},
		]);

		if (this.medicoes) {
			documentDefinition.content.push({
				table: {
					headerRows: 1,
					widths: ['20%', '15%', '15%', '12%', '12%', '12%', '14%'],
					body: this.getDadosVariavelMeteorologicaExportacao(true).map(
						(row, rowIndex) =>
							row.map(cell => ({
								text: cell,
								alignment: 'center',
								fontSize: 12,
								fillColor: rowIndex === 0 ? '#DCDCDC' : null,
							}))
					),
					alignment: 'center',
					layout: 'lightHorizontalLines',
				},
			});
		}
		baixarEAbrirPDF(this.getNomeArquivo(), documentDefinition);
	}

	getDadosVariavelMeteorologicaExportacao(isPdf = false) {
		const tableData: any[][] = [];
		const colunas = [
			'Município/Posto',
			'Latitude',
			'Longitude',
			'Média',
			'Mínima',
			'Máxima',
			'Data',
		];
		tableData.push(colunas);
		const periodo = this.inputs.form
			.get(FormularioRelatorio.PERIODO_BUSCA)
			?.value?.toLowerCase();

		this.medicoes.forEach((item: any) => {
			const periodoFormatado = alinharDado(
				this.formatarDataPeriodo(item.dataColeta, periodo),
				isPdf
			);

			const rowData = [
				alinharDado(
					corrigeDuplicacaoNome(`${item.municipio}/${item.nomePosto}`),
					isPdf,
					'left'
				),
				alinharDado(numberToBrNumberTables(item.latitude, 4), isPdf),
				alinharDado(numberToBrNumberTables(item.longitude, 4), isPdf),
				alinharDado(numberToBrNumberTables(item.valor, 2), isPdf),
				alinharDado(numberToBrNumberTables(item.valorMin, 2), isPdf),
				alinharDado(numberToBrNumberTables(item.valorMax, 2), isPdf),
				periodoFormatado,
			];
			tableData.push(rowData);
		});

		return tableData;
	}

	private formatarDataPeriodo(
		data: Date | string | undefined,
		periodo?: string
	): string {
		if (!data) {
			return '-';
		}
		const dataDate = new Date(data);
		if (periodo === 'mensal') {
			return format(dataDate, 'MM/yyyy', { locale: ptBrLocale });
		}
		if (periodo === 'anual') {
			return format(dataDate, 'yyyy', { locale: ptBrLocale });
		}
		return this.formatData(dataDate);
	}

	formatData(data: Date | string) {
		return format(new Date(data), 'dd/MM/yyyy', { locale: ptBrLocale });
	}

	async getMapImage() {
		await new Promise(resolve => {
			this.mapa.whenReady(() => resolve(true));
		});
		const elementoHtml = document.getElementById('container-mapa');
		if (elementoHtml) {
			const canva = await html2canvas(elementoHtml, {
				useCORS: true,
				allowTaint: true,
				logging: false,
				scale: 2,
			});

			return canva.toDataURL('image/png', 1);
		} else {
			return null;
		}
	}

	getNomeArquivo() {
		const dataFormatada = format(
			new Date(),
			"dd 'de' MMMM 'de' yyyy 'às' HH'h'mm",
			{
				locale: ptBrLocale,
			}
		);
		return `Relatório de variável meteorológica por estação - ${this.labelVariavel} ${this.labelUnidadeVariavel} - exportado em ${dataFormatada}`;
	}

	set isCarregando(value: boolean) {
		this._isCarregando = value;
		this.inputs.setLoading(value);
	}

	get isCarregando() {
		return this._isCarregando;
	}
	ngOnInit(): void {
		this.observarValores();
	}

	ngAfterViewInit(): void {
		this.desenharLimitesMunicipios();
	}

	ngOnDestroy(): void {
		this.inputs.form.get(FormularioRelatorio.AGRUPAMENTO)?.clearValidators();
		this.inputs.form.get(FormularioRelatorio.DATA_INICIO)?.clearValidators();
		this.inputs.form.get(FormularioRelatorio.DATA_FIM)?.clearValidators();
		this._destroyed.next();
		this._destroyed.complete();
	}

	setupMap(mapa: Map) {
		this.mapa = mapa;
	}

	onDadosCarregados() {
		if (this.mapa) {
			setTimeout(() => {
				this.mapa.invalidateSize();
			}, 100);
		}
	}

	desenharLimitesMunicipios() {
		const style: StyleFunction<any> = () => ({
			color: '#607d8b',
			opacity: 0.5,
			weight: 2,
			fillOpacity: 0.05,
		});

		if (this.geoJsonLayer) {
			this.geoJsonLayer.remove();
			this.geoJsonLayer.clearLayers();
		}

		const caminhoGeoJSON = 'assets/geoJson/pb-municipios-geo.json';

		this.httpClient.get<GeoJSON.GeoJsonObject>(caminhoGeoJSON).subscribe({
			next: value => {
				this.geoJsonLayer = geoJSON(value, {
					interactive: false,
					style,
				}).addTo(this.mapa);
			},
		});
	}

	getVariavel() {
		return this.inputs.form.get(
			FormularioRelatorio.VARIAVEL_ACOMPANHAMENTO_COLETA
		)?.value;
	}

	getLabelVariavel() {
		return VariavelAcompanhamentoColeta[
			this.getVariavel() as keyof typeof VariavelAcompanhamentoColeta
		];
	}

	private deveMostrarAcumulado() {
		return ['EVAPOTRANSPIRACAO', 'PRECIPITACAO_DO_PERIODO'].includes(
			this.getVariavel()
		);
	}

	private get medicoesAgrupadas(): RelatorioVariavelEstacao[] {
		const medicoesPorPosto: RelatorioVariavelEstacao[] = [];

		this.medicoes.forEach(med => {
			const indice = medicoesPorPosto.findIndex(
				m => m.estacaoId === med.estacaoId
			);
			const medicaoJaFoiAdicionada = indice !== -1;
			if (medicaoJaFoiAdicionada) {
				const medicaoJaPresente = medicoesPorPosto[indice];
				medicoesPorPosto[indice] = {
					...medicaoJaPresente,
					valorSomado:
						(med.valorSomado ?? 0) + (medicaoJaPresente.valorSomado ?? 0),
				};
			} else {
				medicoesPorPosto.push(med);
			}
		});
		return medicoesPorPosto;
	}

	private atualizaMarkers() {
		if (this.medicoes) {
			this.markersLayer.clearLayers();
			const deveMostrarAcumulado = this.deveMostrarAcumulado();
			this.medicoesAgrupadas
				.filter(m =>
					isNotNuloOuUndefined(deveMostrarAcumulado ? m.valorSomado : m.valor)
				)
				.forEach(m => {
					const cor = this.getCorIcone();
					this.mapa.createPane('markers');
					this.mapa.getPane('markers')!.style.zIndex = '1000';
					const valor = deveMostrarAcumulado ? m.valorSomado : m.valor;
					const conteudoIcone = numberToBrNumber(valor, 1);
					const iconeDiv = divIcon({
						className: '',
						html: `<div style="
                      width: 31px;
                      height: 31px;
                      background-color: ${cor};
                      border-radius: 50%;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      color: ${
												ColorUtils.ehCorClara(cor) ? '#656769' : '#FEFEFE'
											};
                      font-size: ${conteudoIcone.length > 4 ? '10px' : '12px'};
                      font-weight: bold;">
                        ${conteudoIcone}
                      </div>`,
						iconSize: [10, 10],
						iconAnchor: [2.5, 2.5],
					});
					const markerIcone = marker([m.latitude, m.longitude], {
						icon: iconeDiv,
						pane: 'markers',
					}).addTo(this.markersLayer);
					const popup = this.handleAttachPopup(
						this.getPopupVariaveisMunicipio(m, cor)
					);
					markerIcone.bindPopup(popup, {
						offset: new Point(10, 0),
						closeButton: false,
					});
				});
			if (this.mapa) {
				this.markersLayer.addTo(this.mapa);
			}
		}
	}

	private getPopupVariaveisMunicipio(
		medicoes: RelatorioVariavelEstacao,
		cor: string
	) {
		const componentRef = createComponent(PopupVariaveisMunicipioComponent, {
			environmentInjector: this.envInjector,
		});
		componentRef.instance.estacaoMedicoes = medicoes;
		componentRef.instance.cor = cor;
		const variavel = this.getVariavel();
		const nomeVariavel =
			VariavelAcompanhamentoColeta[
				variavel as keyof typeof VariavelAcompanhamentoColeta
			];
		const isDirecao = (variavel as string).includes('DIRECAO');
		componentRef.instance.deveMostrarAcumulado = this.deveMostrarAcumulado();
		componentRef.instance.deveMostrarMedia =
			!componentRef.instance.deveMostrarAcumulado;
		componentRef.instance.nomeVariavel = nomeVariavel;
		componentRef.instance.unidade = getUnidadeVariavelAcompanhamentoColeta(
			variavel,
			!isDirecao
		);
		componentRef.instance.isUnidadeNoValor = isDirecao;
		return componentRef;
	}

	private handleAttachPopup(
		compRef: ComponentRef<PopupVariaveisMunicipioComponent>
	) {
		this.appRef.attachView(compRef.hostView);
		compRef.onDestroy(() => this.appRef.detachView(compRef.hostView));

		const div = document.createElement('div');
		div.appendChild(compRef.location.nativeElement);
		return div;
	}

	private getCorIcone(): string {
		switch (
			VariavelAcompanhamentoColeta[
				this.getVariavel() as keyof typeof VariavelAcompanhamentoColeta
			]
		) {
			case VariavelAcompanhamentoColeta.TEMPERATURA_DO_AR:
			case VariavelAcompanhamentoColeta.TEMPERATURA_DO_SOLO_10CM:
			case VariavelAcompanhamentoColeta.TEMPERATURA_DO_SOLO_20CM:
			case VariavelAcompanhamentoColeta.TEMPERATURA_DO_SOLO_30CM:
			case VariavelAcompanhamentoColeta.TEMPERATURA_DO_SOLO_40CM:
			case VariavelAcompanhamentoColeta.TEMPERATURA_DO_SOLO_50CM:
			case VariavelAcompanhamentoColeta.TEMPERATURA_DO_SOLO_60CM:
				return '#00538f';
			case VariavelAcompanhamentoColeta.CONTEUDO_AGUA_SOLO_10CM:
			case VariavelAcompanhamentoColeta.CONTEUDO_AGUA_SOLO_20CM:
			case VariavelAcompanhamentoColeta.CONTEUDO_AGUA_SOLO_30CM:
			case VariavelAcompanhamentoColeta.CONTEUDO_AGUA_SOLO_40CM:
			case VariavelAcompanhamentoColeta.CONTEUDO_AGUA_SOLO_50CM:
			case VariavelAcompanhamentoColeta.CONTEUDO_AGUA_SOLO_60CM:
			case VariavelAcompanhamentoColeta.UMIDADE_DO_AR:
			case VariavelAcompanhamentoColeta.PRECIPITACAO_DO_PERIODO:
				return '#5DDCF5';
			case VariavelAcompanhamentoColeta.RADIACAO_SOLAR:
				return '#FFF000';
			default:
				return '#83E954';
			case VariavelAcompanhamentoColeta.VENTO_DIRECAO_1:
			case VariavelAcompanhamentoColeta.VENTO_DIRECAO_1_DESVIO_PADRAO:
			case VariavelAcompanhamentoColeta.VENTO_DIRECAO_2:
			case VariavelAcompanhamentoColeta.VENTO_DIRECAO_2_DESVIO_PADRAO:
			case VariavelAcompanhamentoColeta.VENTO_DIRECAO_1_NA_MAXIMA:
			case VariavelAcompanhamentoColeta.VENTO_DIRECAO_2_NA_MAXIMA:
			case VariavelAcompanhamentoColeta.VENTO_VELOCIDADE_1:
			case VariavelAcompanhamentoColeta.VENTO_VELOCIDADE_2:
			case VariavelAcompanhamentoColeta.VENTO_VELOCIDADE_1_MAXIMA:
			case VariavelAcompanhamentoColeta.VENTO_VELOCIDADE_2_MAXIMA:
				return '#F8A135';
		}
	}

	get dataInicio(): Date {
		return this.inputs.form.get(FormularioRelatorio.DATA_INICIO)!.value;
	}

	get dataFim(): Date {
		return this.inputs.form.get(FormularioRelatorio.DATA_FIM)!.value;
	}

	gerarRelatorio(): void {
		this.isCarregando = true;
		const periodo =
			this.inputs.form
				.get(FormularioRelatorio.PERIODO_BUSCA)
				?.value?.toLowerCase() || 'diario';
		const labelAntesRequisicao = this.labelVariavel;
		this.labelVariavel = this.getLabelVariavel();

		this.variavelService
			.getMedicoesDeVariavel(
				this.getVariavel(),
				this.dataInicio,
				this.dataFim,
				periodo
			)
			.subscribe({
				next: resp => {
					this.medicoes = resp;
					this.medicoes = this.medicoes.sort((a, b) =>
						a.municipio.localeCompare(b.municipio)
					);
					this.onDadosCarregados();

					const peloMenosUmaMedicaoValida = this.medicoes.some(
						m => m.valor !== null || m.valorMax !== null || m.valorMin !== 0
					);

					if (peloMenosUmaMedicaoValida) {
						this.relatoriosService.atualizaVisibilidadeBotoesExportacao(resp);
					} else {
						this.relatoriosService.atualizaVisibilidadeBotoesExportacao([]);
					}

					this.atualizaMarkers();
					this.mapa.setView(this.centerDefault, this.zoomDefault);
					this.isCarregando = false;
					const variavel: keyof typeof VariavelAcompanhamentoColeta =
						this.getVariavel();
					this.labelUnidadeVariavel =
						getUnidadeVariavelAcompanhamentoColeta(variavel);
					this.labelPeriodo = `${DateTimeUtils.formatarData(
						this.dataInicio.toISOString(),
						'dd/MM/yyyy'
					)} a ${DateTimeUtils.formatarData(
						this.dataFim.toISOString(),
						'dd/MM/yyyy'
					)}`;
				},
				error: (resp: HttpErrorResponse) => {
					this.isCarregando = false;
					this.labelVariavel = labelAntesRequisicao;
					this.toastr.error(
						resp.message,
						'Erro ao obter informações do posto selecionado'
					);
				},
			});
	}
	observarValores() {
		this.inputs.form
			.get(FormularioRelatorio.PERIODO_BUSCA)
			?.valueChanges.pipe(takeUntil(this._destroyed))
			.subscribe({
				next: (periodoValue: string) => {
					if (periodoValue.toUpperCase() === 'ANUAL') {
						const anoAtual = new Date().getFullYear();
						this.inputs.form.patchValue({
							dataInicio: new Date(anoAtual, 0, 1),
							dataFim: new Date(anoAtual, 11, 31),
						});
					}
				},
			});

		this.inputs.form
			.get(FormularioRelatorio.DATA_INICIO)
			?.valueChanges.pipe(takeUntil(this._destroyed))
			.subscribe({
				next: (novaDataInicioValue: Date | string) => {
					if (
						this.inputs.form
							.get(FormularioRelatorio.PERIODO_BUSCA)
							?.value?.toUpperCase() === 'ANUAL'
					) {
						const novaDataInicio = new Date(novaDataInicioValue);
						const anoNovaDataInicio = novaDataInicio.getFullYear();
						const dataFimAtual = new Date(this.dataFim);

						if (
							dataFimAtual.getFullYear() !== anoNovaDataInicio ||
							dataFimAtual.getMonth() !== 11 ||
							dataFimAtual.getDate() !== 31
						) {
							this.inputs.form.patchValue(
								{
									dataFim: new Date(anoNovaDataInicio, 11, 31),
								},
								{ emitEvent: false }
							);
						}
					}
				},
			});

		this.inputs.form
			.get(FormularioRelatorio.DATA_FIM)
			?.valueChanges.pipe(takeUntil(this._destroyed))
			.subscribe({
				next: (novaDataFimValue: Date | string) => {
					if (
						this.inputs.form
							.get(FormularioRelatorio.PERIODO_BUSCA)
							?.value?.toUpperCase() === 'ANUAL'
					) {
						const novaDataFim = new Date(novaDataFimValue);
						const anoNovaDataFim = novaDataFim.getFullYear();
						const dataInicioAtual = this.dataInicio;

						if (
							dataInicioAtual.getFullYear() !== anoNovaDataFim ||
							dataInicioAtual.getMonth() !== 0 ||
							dataInicioAtual.getDate() !== 1
						) {
							this.inputs.form.patchValue(
								{
									dataInicio: new Date(anoNovaDataFim, 0, 1),
								},
								{ emitEvent: false }
							);
						}
					}
				},
			});
	}
}
